export default __webpack_public_path__ + "static/media/Rank table card.444bd524.svg";